import { render, staticRenderFns } from "./AddToCartButton.vue?vue&type=template&id=6a5ec81c&scoped=true&"
import script from "./AddToCartButton.vue?vue&type=script&lang=js&"
export * from "./AddToCartButton.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartButton.vue?vue&type=style&index=0&id=6a5ec81c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ec81c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
